

// Menu drawer code to change tab
$(document).on("click",".tabs .tablinksone",function() {
  $(".tablinkstwo").removeClass("active")
     $(this).addClass("active");
     $(".drawer__content .tabcontent").removeClass("active");
       $(".drawer__content #tab1").addClass("active");
    
});

$(document).on("click",".tabs .tablinkstwo",function() {
  $(".tablinksone").removeClass("active")
     $(this).addClass("active");
     $(".drawer__content .tabcontent").removeClass("active");
       $(".drawer__content #tab2").addClass("active");
    
});

// $(document).on("click",".customstickyselect",function() {
//   var data = $(this).attr("data-qty");   
//   $(".qty-discount-input").attr("value",data);
// });

$(document).ready(function(){
  $(".category_list .category_arrow").click(function(){
    var $categoryList = $(this).closest(".category_list");
    $categoryList.find(".category_icons").slideToggle("slow");
    $categoryList.find(".category_arrow").toggleClass("open_category");
  });
});


document.addEventListener('cart:updated', function(event) {
   setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 1000);
});

document.addEventListener('variant:added', function(event) {
   setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 1000);
});

$(document).on("click",".custom_recoment_cart",function() {
   setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 1000);
});

$(document).on("click",".add-to-carts",function() {
     setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 1000);
});


$(document).ready(function(){
   setTimeout(function () {
ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
   }, 2500);
  });

document.addEventListener('cart:updated', function(event) {
   setTimeout(function () {
ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
   }, 2500);
  
 });


  document.addEventListener('variant:added', function(event) {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
// console.log("Fffffff")
    
  });

$(document).on("click",".add-to-carts",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 2500);
console.log("Fffffff")
    
  });

$(document).on("click",".custom_recoment_cart",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 2500);
console.log("Fffffff")
    
  });

$(document).on("click",".pagination__nav-item",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 1000);
console.log("Fffffff")
    
  });


$(document).on("click",".popover__choice-item",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 1000);
console.log("Fffffff")
    
  });

$(document).on("click",".checkbox-container",function() {
     setTimeout(function () {
 ratingSnippet("ruk_rating_snippet", {
  store: "true-nature.de",
  mode: "default",
  color: "#0E1311",
  linebreak: false,
  text: "<span class='custom-space-match-review'></span>",
  singularText: "<span class='custom-space-match-review'></span>",
  lang: "en",
  usePolaris: true,
  showEmptyStars: false,
});
        }, 1000);
console.log("Fffffff")
    
  });

$("#reviews_container").on('click', function(){ 
     $('html').addClass('lock-all');
      $("#mini-cart").attr('open','open');
})
$(document).on("click","body #reviews_fade, body #reviews_widget, body #reviews_container",function() {

  $('html').addClass('lock-all');
  //document.getElementsByClassName('mini_cart_drawer')[0].setAttribute("open", "open");
  $("#mini-cart").attr('open','open');
});


// Rerun the reviews.co.uk rating snippet after the mini-cart has been re-rendered.
// The cart-drawer replaces its innerHTML on `cart:refresh` (see theme.js _rerenderCart),
// which wipes any previously rendered star markup. Inline <script> tags placed inside
// the section do not execute after innerHTML assignment, so we need to re-invoke
// ratingSnippet() ourselves. `cart:refresh` is dispatched on document.documentElement
// without `bubbles: true` from js-variables.liquid on pageshow, so we must listen on
// documentElement (otherwise the listener on `document` never fires for that case).
(function () {
  function _reinitMiniCartRatings() {
    if (typeof window.ratingSnippet !== 'function') return;
    try {
      window.ratingSnippet('ruk_rating_snippet', {
        store: 'true-nature.de',
        mode: 'default',
        color: '#0E1311',
        linebreak: false,
        text: "<span class='custom-space-match-review'></span>",
        singularText: "<span class='custom-space-match-review'></span>",
        lang: 'en',
        usePolaris: true,
        showEmptyStars: false,
      });
    } catch (e) {}
  }

  function _reinitMiniCartRatingsWithRetries() {
    // _rerenderCart is async (fetch section HTML + setTimeout for replacementDelay
    // up to ~750ms). Retry several times to cover all timings without re-rendering
    // too eagerly.
    [400, 900, 1600, 2800].forEach(function (delay) {
      setTimeout(_reinitMiniCartRatings, delay);
    });

    setTimeout(function () {
      $('.ruk_rating_snippet').hover(
        function () {
          $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function () {
          $(this).attr('title', $(this).data('title'));
        }
      );
    }, 2800);
  }

  document.documentElement.addEventListener('cart:refresh', _reinitMiniCartRatingsWithRetries);
})();

(function () {
  var COOKIE_NAME = 'tn_recently_viewed';
  var COOKIE_DAYS = 90;
  var MAX_STORED = 10;

  function readCookie() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return [];
    try {
      var raw = decodeURIComponent(match[1]);
      var arr = JSON.parse(raw);
      if (Array.isArray(arr)) return arr.filter(function (h) { return typeof h === 'string' && h.length > 0; });
    } catch (e) {}
    return [];
  }

  function writeCookie(list) {
    var expires = new Date();
    expires.setTime(expires.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(list)) + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
  }

  function pushHandle(handle) {
    if (!handle) return;
    var list = readCookie();
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    writeCookie(list);
  }

  function currentProductHandle() {
    var meta = document.querySelector('meta[property="og:url"]');
    var candidate = (meta && meta.content) || window.location.pathname;
    var match = candidate.match(/\/products\/([^\/?#]+)/);
    if (!match) return null;
    var handle = match[1].split('?')[0].split('#')[0];
    var lower = handle.toLowerCase();
    if (lower === 'rabatt' || lower === 'all' || lower === 'gifts') return null;
    return handle;
  }

  function isProductPage() {
    if (document.body && document.body.classList.contains('single-product-page')) return true;
    return /\/products\/[^\/?#]+/.test(window.location.pathname);
  }

  function track() {
    if (!isProductPage()) return;
    var handle = currentProductHandle();
    if (handle) pushHandle(handle);
  }

  window.tnRecentlyViewed = {
    get: readCookie,
    clear: function () { writeCookie([]); },
    push: pushHandle
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', track);
  } else {
    track();
  }
})();

(function () {
  var MONEY_FORMAT_DEFAULT = '{{amount}}€';

  function getMoneyFormat(root) {
    var fmt = (root && root.getAttribute('data-money-format')) || '';
    if (fmt) return fmt;
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) {
      return window.themeVariables.settings.moneyFormat;
    }
    return MONEY_FORMAT_DEFAULT;
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    var amount = (cents / 100).toFixed(2);
    var withoutDecimals = Math.round(cents / 100).toString();
    var commaDecimals = amount.replace('.', ',');
    return String(format || MONEY_FORMAT_DEFAULT)
      .replace(/\{\{\s*amount\s*\}\}/g, commaDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withoutDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaDecimals)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withoutDecimals);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function productImage(product, size) {
    var url = product.featured_image || (product.images && product.images[0]) || '';
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function ctaIconSvg() {
    return '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M7.10011 10.5C7.10011 10.7761 6.87624 11 6.60011 11H5.50003C4.42093 11 3.43779 10.166 3.26152 9.10155L2.08697 2.07762C2.06768 1.9597 1.93218 1.77367 1.82769 1.7202L0.276923 0.947493C0.0298542 0.824202 -0.0704868 0.524153 0.0525591 0.276838C0.175849 0.0302554 0.475407 -0.0705747 0.723208 0.0524723L2.27788 0.827376C2.67021 1.02757 3.00322 1.48387 3.07353 1.91454L3.33867 3.49999H14.5C14.6523 3.49999 14.7963 3.56932 14.8911 3.68871C14.986 3.80785 15.0214 3.96385 14.9873 4.11229L14.2822 7.17235C14.2287 7.40356 14.0229 7.56005 13.7954 7.56005C13.7583 7.56005 13.7204 7.5559 13.6826 7.54735C13.4135 7.48534 13.2456 7.21679 13.3076 6.94774L13.8715 4.49999H3.5059L4.24808 8.93749C4.3433 9.51391 4.91653 9.99999 5.50003 9.99999H6.60011C6.87624 9.99999 7.10011 10.2239 7.10011 10.5ZM7.00001 13.5C7.00001 14.3271 6.32717 15 5.50003 15C4.67288 15 4.00004 14.3271 4.00004 13.5C4.00004 12.6728 4.67288 12 5.50003 12C6.32717 12 7.00001 12.6728 7.00001 13.5ZM6.00002 13.5C6.00002 13.2244 5.77566 13 5.50003 13C5.22439 13 5.00003 13.2244 5.00003 13.5C5.00003 13.7756 5.22439 14 5.50003 14C5.77566 14 6.00002 13.7756 6.00002 13.5ZM15 11.5C15 13.4299 13.4299 15 11.5 15C9.57006 15 8.00001 13.4299 8.00001 11.5C8.00001 9.57006 9.57006 7.99999 11.5 7.99999C13.4299 7.99999 15 9.57006 15 11.5ZM14 11.5C14 10.1216 12.8784 8.99999 11.5 8.99999C10.1216 8.99999 9 10.1216 9 11.5C9 12.8784 10.1216 14 11.5 14C12.8784 14 14 12.8784 14 11.5ZM12.5 11H12V10.5C12 10.2239 11.7761 9.99999 11.5 9.99999C11.2239 9.99999 11 10.2239 11 10.5V11H10.5C10.2239 11 9.99999 11.2239 9.99999 11.5C9.99999 11.7761 10.2239 12 10.5 12H11V12.5C11 12.7761 11.2239 13 11.5 13C11.7761 13 12 12.7761 12 12.5V12H12.5C12.7761 12 13 11.7761 13 11.5C13 11.2239 12.7761 11 12.5 11Z" fill="currentColor"/>' +
      '</svg>';
  }

  function buildCardHtml(product, moneyFormat) {
    var variant = null;
    if (product.variants && product.variants.length) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) { variant = product.variants[i]; break; }
      }
      if (!variant) variant = product.variants[0];
    }
    if (!variant) return '';

    var price = typeof variant.price === 'number' ? variant.price : parseFloat(variant.price) * 100;
    var compare = typeof variant.compare_at_price === 'number' ? variant.compare_at_price : (variant.compare_at_price ? parseFloat(variant.compare_at_price) * 100 : 0);

    var skuList = (product.variants || []).map(function (v) { return v.sku || ''; }).filter(Boolean).join(';');
    var idList = (product.variants || []).map(function (v) { return v.id; }).join(';');
    var ratingSku = escapeHtml(product.handle + ';' + skuList + ';' + idList);

    var url = product.url || ('/products/' + product.handle);
    var img = productImage(product, 130);
    var title = escapeHtml(product.title || '');
    var variantTitle = (variant.title && variant.title !== 'Default Title') ? escapeHtml(variant.title) : '';

    var compareHtml = compare && compare > price
      ? '<span class="mc-upsell__cta-compare">' + formatMoney(compare, moneyFormat) + '</span>'
      : '';

    var disabledAttr = variant.available ? '' : 'disabled aria-disabled="true"';

    return (
      '<div class="mc-upsell__slide" data-handle="' + escapeHtml(product.handle) + '">' +
        '<article class="mc-upsell__card">' +
          '<a class="mc-upsell__card-image" href="' + escapeHtml(url) + '" aria-label="' + title + '" tabindex="-1">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="' + title + '" loading="lazy" width="65" height="65">' : '') +
          '</a>' +
          '<div class="mc-upsell__card-body">' +
            '<div class="mc-upsell__card-rating feature_prod_rating">' +
              '<div class="ruk_rating_snippet" data-sku="' + ratingSku + '"></div>' +
            '</div>' +
            '<a class="mc-upsell__card-title" href="' + escapeHtml(url) + '">' + title + '</a>' +
            (variantTitle ? '<p class="mc-upsell__card-subtitle">' + variantTitle + '</p>' : '') +
            '<form class="mc-upsell__form" action="/cart/add" method="post" data-mc-upsell-form>' +
              '<input type="hidden" name="id" value="' + variant.id + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button type="submit" class="mc-upsell__cta" ' + disabledAttr + ' data-mc-upsell-cta>' +
                '<span class="mc-upsell__cta-spinner" aria-hidden="true"></span>' +
                '<span class="mc-upsell__cta-content">' +
                  '<span class="mc-upsell__cta-icon" aria-hidden="true">' + ctaIconSvg() + '</span>' +
                  '<span class="mc-upsell__cta-price">' + formatMoney(price, moneyFormat) + '</span>' +
                  compareHtml +
                '</span>' +
              '</button>' +
            '</form>' +
          '</div>' +
        '</article>' +
      '</div>'
    );
  }

  function parseCartHandles(root) {
    var raw = (root && root.getAttribute('data-cart-handles')) || '';
    return raw.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
  }

  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('not_found'); return res.json(); })
      .then(function (product) { productCache[handle] = product; return product; })
      .catch(function () { return null; });
  }

  function maybeReinitRatings() {
    if (typeof window.ratingSnippet !== 'function') return;
    try {
      window.ratingSnippet('ruk_rating_snippet', {
        store: 'true-nature.de',
        mode: 'default',
        color: '#0E1311',
        linebreak: false,
        text: "<span class='custom-space-match-review'></span>",
        singularText: "<span class='custom-space-match-review'></span>",
        lang: 'en',
        usePolaris: true,
        showEmptyStars: false
      });
    } catch (e) {}
  }

  function updateDots(root) {
    var viewport = root.querySelector('[data-mc-upsell-viewport]');
    var dotsEl = root.querySelector('[data-mc-upsell-dots]');
    if (!viewport || !dotsEl) return;

    var slides = root.querySelectorAll('.mc-upsell__slide');
    dotsEl.innerHTML = '';
    if (slides.length <= 1) return;

    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mc-upsell__dot';
      dot.setAttribute('data-mc-upsell-dot', String(i));
      dot.setAttribute('aria-label', 'Zu Produkt ' + (i + 1));
      dotsEl.appendChild(dot);
    }

    function setActive(index) {
      var dots = dotsEl.querySelectorAll('.mc-upsell__dot');
      for (var i = 0; i < dots.length; i++) {
        if (i === index) dots[i].classList.add('is-active');
        else dots[i].classList.remove('is-active');
      }
    }

    function computeActive() {
      var left = viewport.scrollLeft;
      var slideNodes = root.querySelectorAll('.mc-upsell__slide');
      if (!slideNodes.length) return 0;
      var first = slideNodes[0];
      var style = window.getComputedStyle(viewport.querySelector('.mc-upsell__track'));
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      var step = first.offsetWidth + gap;
      if (step <= 0) return 0;
      var idx = Math.round(left / step);
      if (idx < 0) idx = 0;
      if (idx > slideNodes.length - 1) idx = slideNodes.length - 1;
      return idx;
    }

    var scheduled = false;
    function onScroll() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        setActive(computeActive());
      });
    }

    viewport.addEventListener('scroll', onScroll, { passive: true });

    dotsEl.addEventListener('click', function (event) {
      var target = event.target.closest('[data-mc-upsell-dot]');
      if (!target) return;
      var index = parseInt(target.getAttribute('data-mc-upsell-dot'), 10);
      var slideNodes = root.querySelectorAll('.mc-upsell__slide');
      if (!slideNodes[index]) return;
      var track = viewport.querySelector('.mc-upsell__track');
      var style = track ? window.getComputedStyle(track) : null;
      var gap = style ? (parseFloat(style.columnGap || style.gap || '0') || 0) : 0;
      var step = slideNodes[0].offsetWidth + gap;
      viewport.scrollTo({ left: step * index, behavior: 'smooth' });
    });

    setActive(computeActive());
  }

  function renderProducts(root, products) {
    var track = root.querySelector('[data-mc-upsell-track]');
    if (!track) return;
    var format = getMoneyFormat(root);
    var html = products.map(function (p) { return buildCardHtml(p, format); }).filter(Boolean).join('');
    track.innerHTML = html;
    var viewport = root.querySelector('[data-mc-upsell-viewport]');
    if (viewport) viewport.scrollLeft = 0;
    updateDots(root);
    setTimeout(maybeReinitRatings, 50);
    setTimeout(maybeReinitRatings, 600);
  }

  function plannedRecentHandles(root) {
    var handles = (window.tnRecentlyViewed && window.tnRecentlyViewed.get()) || [];
    if (handles.length < 2) return [];
    var cartHandles = parseCartHandles(root);
    var max = parseInt(root.getAttribute('data-max-items'), 10) || 8;
    var filtered = handles.filter(function (h) { return cartHandles.indexOf(h) === -1; }).slice(0, max);
    return filtered.length >= 2 ? filtered : [];
  }

  function hydrateFromRecentlyViewed(root, planned) {
    var list = planned || plannedRecentHandles(root);
    if (!list.length) {
      root.classList.add('is-fallback-ready');
      return;
    }

    Promise.all(list.map(fetchProduct))
      .then(function (products) {
        var valid = products.filter(function (p) { return p && p.variants && p.variants.length; });
        if (valid.length < 2) {
          root.classList.remove('is-hydrating');
          root.classList.add('is-fallback-ready');
          return;
        }
        renderProducts(root, valid);
        root.classList.remove('is-hydrating');
        root.classList.add('is-recent-ready');
      })
      .catch(function () {
        root.classList.remove('is-hydrating');
        root.classList.add('is-fallback-ready');
      });
  }

  function ajaxAddToCart(form, cta) {
    if (!form || cta.disabled) return;
    cta.classList.add('is-loading');
    cta.setAttribute('aria-busy', 'true');
    cta.disabled = true;

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cart, openMiniCart: false }
        }));
      })
      .catch(function () {
        cta.classList.remove('is-loading');
        cta.removeAttribute('aria-busy');
        cta.disabled = false;
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-mc-upsell-form]');
    if (!form) return;
    event.preventDefault();
    var cta = form.querySelector('[data-mc-upsell-cta]');
    if (!cta) return;
    ajaxAddToCart(form, cta);
  });

  function setupDrag(root) {
    var viewport = root.querySelector('[data-mc-upsell-viewport]');
    if (!viewport) return;

    var DRAG_THRESHOLD = 5;
    var startX = 0;
    var startScroll = 0;
    var activePointerId = null;
    var pending = false;
    var dragging = false;

    function suppressNextClick() {
      var suppressor = function (event) {
        event.preventDefault();
        event.stopPropagation();
        document.removeEventListener('click', suppressor, true);
      };
      document.addEventListener('click', suppressor, true);
      setTimeout(function () { document.removeEventListener('click', suppressor, true); }, 400);
    }

    function endDrag(event) {
      if (!pending && !dragging) return;
      if (activePointerId !== null) {
        try { viewport.releasePointerCapture(activePointerId); } catch (e) {}
      }
      var wasDragging = dragging;
      pending = false;
      dragging = false;
      activePointerId = null;
      root.classList.remove('is-dragging');
      viewport.removeEventListener('pointermove', onMove);
      viewport.removeEventListener('pointerup', endDrag);
      viewport.removeEventListener('pointercancel', endDrag);
      if (wasDragging) {
        suppressNextClick();
        var slides = root.querySelectorAll('.mc-upsell__slide');
        if (slides.length > 0) {
          var track = viewport.querySelector('.mc-upsell__track');
          var style = track ? window.getComputedStyle(track) : null;
          var gap = style ? (parseFloat(style.columnGap || style.gap || '0') || 0) : 0;
          var step = slides[0].offsetWidth + gap;
          if (step > 0) {
            var idx = Math.round(viewport.scrollLeft / step);
            if (idx < 0) idx = 0;
            if (idx > slides.length - 1) idx = slides.length - 1;
            viewport.scrollTo({ left: step * idx, behavior: 'smooth' });
          }
        }
      }
    }

    function onMove(event) {
      if (activePointerId !== event.pointerId) return;
      var delta = event.clientX - startX;
      if (!dragging) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        dragging = true;
        root.classList.add('is-dragging');
        try { viewport.setPointerCapture(event.pointerId); } catch (e) {}
      }
      event.preventDefault();
      viewport.scrollLeft = startScroll - delta;
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.button !== undefined && event.button !== 0) return;
      pending = true;
      dragging = false;
      activePointerId = event.pointerId;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
      viewport.addEventListener('pointermove', onMove);
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
    });

    viewport.addEventListener('dragstart', function (event) { event.preventDefault(); });
  }

  function bootCarousel(root) {
    if (root.dataset.mcUpsellReady === '1') return;
    root.dataset.mcUpsellReady = '1';

    var planned = plannedRecentHandles(root);
    if (planned.length) {
      root.classList.add('is-hydrating');
    } else {
      root.classList.add('is-fallback-ready');
    }

    setupDrag(root);
    updateDots(root);
    hydrateFromRecentlyViewed(root, planned);
  }

  function registerCustomElement() {
    if (typeof window.customElements === 'undefined') return false;
    if (window.customElements.get('mc-upsell-carousel')) return true;
    try {
      class McUpsellCarousel extends HTMLElement {
        connectedCallback() { bootCarousel(this); }
      }
      window.customElements.define('mc-upsell-carousel', McUpsellCarousel);
      return true;
    } catch (e) {
      return false;
    }
  }

  if (!registerCustomElement()) {
    var existing = document.querySelectorAll('mc-upsell-carousel');
    for (var i = 0; i < existing.length; i++) bootCarousel(existing[i]);
    document.documentElement.addEventListener('cart:refresh', function () {
      setTimeout(function () {
        var nodes = document.querySelectorAll('mc-upsell-carousel');
        for (var n = 0; n < nodes.length; n++) bootCarousel(nodes[n]);
      }, 0);
    });
  }
})();

(function () {
  var MAX_ITEMS = 3;
  var MONEY_FORMAT_DEFAULT = '{{amount}}€';

  function getMoneyFormat(root) {
    var fmt = (root && root.getAttribute('data-money-format')) || '';
    if (fmt) return fmt;
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) {
      return window.themeVariables.settings.moneyFormat;
    }
    return MONEY_FORMAT_DEFAULT;
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    var amount = (cents / 100).toFixed(2);
    var withoutDecimals = Math.round(cents / 100).toString();
    var commaDecimals = amount.replace('.', ',');
    return String(format || MONEY_FORMAT_DEFAULT)
      .replace(/\{\{\s*amount\s*\}\}/g, commaDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withoutDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaDecimals)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withoutDecimals);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function productImage(product, size) {
    var url = product.featured_image || (product.images && product.images[0]) || '';
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function pickVariant(product) {
    var variants = product.variants || [];
    return variants[0] || null;
  }

  function toCents(value) {
    if (typeof value === 'number') return value;
    if (!value) return 0;
    var asFloat = parseFloat(value);
    if (!isFinite(asFloat)) return 0;
    if (asFloat >= 100 || String(value).indexOf('.') === -1) return Math.round(asFloat);
    return Math.round(asFloat * 100);
  }

  function buildRowHtml(product, moneyFormat) {
    var variant = pickVariant(product);
    var price = toCents(product.price);
    var compare = toCents(product.compare_at_price);
    if (variant) {
      if (variant.price != null) price = toCents(variant.price);
      if (variant.compare_at_price != null) compare = toCents(variant.compare_at_price);
    }

    var url = product.url || ('/products/' + product.handle);
    url = String(url).split('?')[0];
    var img = productImage(product, 140);
    var title = escapeHtml(product.title || '');
    var subtitle = '';
    if (variant && variant.title && variant.title !== 'Default Title') {
      subtitle = /Monat/i.test(variant.title)
        ? escapeHtml(variant.title) + ' Reichweite'
        : escapeHtml(variant.title);
    }

    var onSale = compare > price && compare > 0;
    var percent = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
    var badge = onSale && percent > 0 ? '<span class="ps-row__badge">-' + percent + '%</span>' : '';
    var compareHtml = onSale ? '<s class="ps-row__compare">' + formatMoney(compare, moneyFormat) + '</s>' : '';

    return (
      '<li class="ps-recent__item">' +
        '<a class="ps-row" href="' + escapeHtml(url) + '">' +
          '<span class="ps-row__media">' +
            (img ? '<img class="ps-row__image" src="' + escapeHtml(img) + '" alt="' + title + '" width="70" height="70" loading="lazy">' : '') +
          '</span>' +
          '<span class="ps-row__info">' +
            '<span class="ps-row__title">' + title + '</span>' +
            (subtitle ? '<span class="ps-row__subtitle">' + subtitle + '</span>' : '') +
          '</span>' +
          '<span class="ps-row__pricing">' +
            badge +
            '<span class="ps-row__prices">' +
              compareHtml +
              '<span class="ps-row__price">' + formatMoney(price, moneyFormat) + '</span>' +
            '</span>' +
          '</span>' +
        '</a>' +
      '</li>'
    );
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('not_found'); return res.json(); })
      .catch(function () { return null; });
  }

  function hydrateRecentlyViewed() {
    var root = document.querySelector('[data-ps-recent]');
    if (!root) return;
    var list = root.querySelector('[data-ps-recent-list]');
    var idle = root.closest('[data-ps-idle]');
    if (!list) return;

    var handles = (window.tnRecentlyViewed && window.tnRecentlyViewed.get()) || [];
    handles = handles.slice(0, MAX_ITEMS);
    if (!handles.length) {
      root.hidden = true;
      if (idle) idle.classList.remove('ps-has-recent');
      return;
    }

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) {
        root.hidden = true;
        if (idle) idle.classList.remove('ps-has-recent');
        return;
      }
      var format = getMoneyFormat(root);
      list.innerHTML = valid.map(function (p) { return buildRowHtml(p, format); }).join('');
      root.hidden = false;
      if (idle) idle.classList.add('ps-has-recent');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateRecentlyViewed);
  } else {
    hydrateRecentlyViewed();
  }

  document.addEventListener('openable-element:open', function (event) {
    if (event.target && event.target.id === 'search-drawer') {
      hydrateRecentlyViewed();
    }
  });
})();
